import { Button, SparkleIcon } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

interface WizardButtonProps {
  className?: string;
  label?: ReactNode;
  onClickStart: () => void;
}

export const WizardButton = ({
  className,
  label = 'Help me choose',
  onClickStart,
}: WizardButtonProps) => {
  return (
    <Button
      className={className}
      data-testid="wizard-button"
      label={label}
      onClick={onClickStart}
      startIcon={<SparkleIcon size="sm" />}
    />
  );
};
